import { useEffect } from "react"
import Icon from "../../components/Icon"

// Lightweight, responsive modal shell: full-height sheet feel on phones,
// centered card on desktop. Closes on backdrop click and Escape.
// `size` only widens the desktop card; phones always use the full width.
const MODAL_SIZES = {
  default: "sm:max-w-lg",
  wide: "sm:max-w-3xl",
}

function Modal({ title, subtitle, icon = "receipt", size = "default", onClose, children, footer }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose?.()
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [onClose])

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-3">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm" onClick={onClose} />
      <div
        className={`relative z-10 flex max-h-[92vh] w-full flex-col overflow-hidden rounded-2xl bg-white shadow-2xl ${
          MODAL_SIZES[size] || MODAL_SIZES.default
        }`}
      >
        <div className="flex items-start gap-3 border-b border-slate-100 bg-gradient-to-r from-emerald-50 to-teal-50 px-4 py-3.5 sm:px-5">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-teal-600 text-white shadow-sm">
            <Icon name={icon} size="1.05rem" />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="truncate text-base font-black text-slate-900">{title}</h3>
            {subtitle && <p className="mt-0.5 truncate text-xs text-slate-500">{subtitle}</p>}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="-mr-1 rounded-lg p-1.5 text-slate-400 transition-colors hover:bg-white/70 hover:text-slate-600"
            aria-label="Close"
          >
            <Icon name="x-lg" size="1.05rem" />
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-5">{children}</div>

        {footer && (
          <div className="border-t border-slate-100 bg-slate-50 px-4 py-3 sm:px-5">{footer}</div>
        )}
      </div>
    </div>
  )
}

export default Modal
